import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      companyInfo: {},
      companyFollowStatus: null,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
  },
  methods: {
    ...mapActions({
      followUnfollowCompany: 'companies/followUnfollowCompany',
      fetchCompany: 'companies/fetchCompany',
    }),
    async followReq() {
      try {
        await this.followUnfollowCompany({
          action: 'follow',
          company: this.companyInfo.url,
        });

        this.companyFollowStatus = !this.companyFollowStatus;
        this.$notify({
          group: 'profile',
          title: 'success',
          text: 'Compamy have been added to your followers list!',
          type: 'success',
        });
      } catch (e) {
        if (e) {
          this.$notify({
            group: 'profile',
            title: 'error',
            text: `${e.name}`,
            type: 'error',
          });
        }
      }
    },
    async UnFollowReq() {
      try {
        await this.followUnfollowCompany({
          action: 'unfollow',
          company: this.companyInfo.url,
        });
        this.companyFollowStatus = !this.companyFollowStatus;
        this.$notify({
          group: 'profile',
          title: 'success',
          text: 'Company have been deleted from your followers list!',
          type: 'success',
        });
      } catch (err) {
        this.$notify({
          group: 'profile',
          title: 'error',
          text: `${err.name}`,
          type: 'error',
        });
      }
    },
    moment(date) {
      return moment(new Date(date));
    },
  },
  async created() {
    const { companyId } = this.$route.params;
    try {
      this.companyInfo = await this.fetchCompany(companyId);
      this.companyFollowStatus = this.companyInfo.follow_status;
    } catch (err) {
      this.$router.push({ name: 'NotFound' });
    }
  },
};
